import {Observable} from "rxjs";

export type OriginatorListValue = {
    originatorBusinessId: number, name: string, salesforceId : string
} | null;
export type OriginatorListValueGetFn = ()=>Observable<Exclude<OriginatorListValue, null>[]>;
